import { useRequest } from "hooks/useRequest";

export const useSuppliersRequester = () => {
	const request = useRequest("Supplier");

	return {
		...request,
	};
};
